var React = require('react');

function ExternalLink (props) {
    return React.createElement("svg",props,React.createElement("g",{"strokeWidth":"1"},React.createElement("g",{"transform":"translate(0.000000, -17.000000)"},[React.createElement("path",{"d":"M65.0787075,33.0882353 L33.4558824,64.3382354","strokeWidth":"15","strokeLinecap":"square","key":0}),React.createElement("polygon",{"transform":"translate(72.134903, 29.456845) rotate(53.000000) translate(-72.134903, -29.456845) ","points":"68.5556866 14.7245467 97.9172862 36.850099 46.3525203 44.1891435","key":1}),React.createElement("polygon",{"points":"48.5294118 28.6764706 0 28.6764706 0 97.7941176 69.1176471 97.7941176 69.1176471 50 58.0882353 61.0294118 58.0882353 86.7647059 11.0294118 86.7647059 11.0294118 39.7058824 37.5 39.7058824","key":2})])));
}

ExternalLink.defaultProps = {"height":"100px","width":"100px","viewBox":"0 0 82 81","version":"1.1","x":"0px","y":"0px"};

module.exports = ExternalLink;

ExternalLink.default = ExternalLink;
